import { ToggleIcon } from 'assets/icons'

interface MembershipCardContentProps {
  title: string | JSX.Element
  badge: JSX.Element | string
  className?: string
  children: JSX.Element
  twoCols?: boolean
  dataTestId?: string
}

const MembershipCardContent = ({
  title,
  badge,
  children,
  className = '',
  twoCols = true,
  dataTestId = null
}: MembershipCardContentProps) => (
  <div
    data-testid={dataTestId}
    className={`py-3 rounded-[10px] flex flex-col items-center justify-between ${
      twoCols &&
      'md:grid md:grid-cols-[1fr_1fr] md:gap-4 ring-2 md:ring-0 ring-green-800'
    } w-full md:p-0 ${className}`}
  >
    <div className='flex flex-col'>
      <div className='mt-2 flex flex-col items-center'>
        <ToggleIcon className='my-4' />
      </div>
      <h3 className='text-purple-900 leading-6 font-bold text-[20px]'>
        {title}
      </h3>
      <div className='flex flex-col items-center my-3'>
        <div className='h-0 w-0 mx-auto border-l-8 border-r-8 border-r-transparent border-l-transparent border-b-8 border-b-blue-900' />
        <p className='bg-blue-900 text-white font-bold text-[10px] py-1 px-3 rounded-xl'>
          {badge}
        </p>
      </div>
    </div>

    <div>{children}</div>
  </div>
)

export default MembershipCardContent
